import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=424c33bc&"
import script from "./UserDisplay.vue?vue&type=script&lang=ts&"
export * from "./UserDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports